module.exports = __webpack_public_path__ + "img/banner-main-s.e5071f28.png";